<template>
<div>
  <div class="overlay">
    <div class="top-text">
      <div class="wip-text">Work In Progress!</div>
    </div>
    <div class="holiday">
      <tl-header type="h3" class="title">
              Holidays
      </tl-header>
      <div class="list-container">
          <div v-for="data in holList" >
              <div class="rect">
                  <span class="dateHol"> {{data.dateOfHoliday}} </span>
                  <div class="rect-details">
                      <span class="monthHol"> <b> {{data.monthOfHoliday}} </b> </span><br>
                      <span class="typeHol"> {{data.typeOfHoliday}} </span>
                  </div>
              </div>

          </div>
          <div class="viewHols">
              <a> VIEW ALL <img src="@/assets/next-icon.png" /> </a>
          </div>
          <div class="line" />
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
    name: "Holidays",
    data() {
        return {
            holList: [{
                dateOfHoliday: '12',
                monthOfHoliday: 'May 2019',
                typeOfHoliday: 'Chill Day'
            },
            {
                dateOfHoliday: '25',
                monthOfHoliday: 'May 2019',
                typeOfHoliday: 'Chill Day'
            },
            {
                dateOfHoliday: '31',
                monthOfHoliday: 'May 2019',
                typeOfHoliday: 'Chill Day'
            }]
        }
    },
    methods: {

    }
}
</script>

<style lang="scss" scoped>
.list-container {
  padding: 18px;
}
.title{
  padding: 20px;
}
.rect {
  display: flex;
  height: 60px;
  border-radius: 3.6px;
  background-color: #f9f9f9;
  margin-bottom: 15px;
}
.rect-details {
    padding: 10px;
}
.dateHol {
  font-size: 26px;
  color: #606060;
  padding: 15px 20px 15px 20px;
}
.monthHol {
  font-size: 14px;
  color: #606060;
}
.typeHol {
  font-size: 12px;
  color: #606060;
}
.viewHols {
    display: flex;
    padding: 200px 0px 0px 50px;
    a {
        font-size: 12px;
        font-weight: bold;
        color: #5d409f;
    }
    img {
        margin-left: 10px;
    }

}
.line {
        color: #5d409f;
        width: 62px;
        height: 1px;
        border: solid 1px #5d409f;
        margin-bottom: 10px;
        margin-left: 50px;
    }

.overlay {
  position: relative;
}

.top-text {
  position: absolute;
  background-color: rgba(255, 255, 255, 0.8);
  width: 100%;
  height: 100%;
  z-index: 1;
}
.wip-text {
  font-family: Montserrat;
  font-size: 32px;
  font-weight: 600;
  text-align: center;
  color: #444444;
  margin-top: 30%;
  transform: rotate(-45deg);
}
.holiday {
  position: relative;
}
</style>
